import { useState, type FormEvent } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Brand } from "../components/Brand";

export function LoginPage() {
  const { user, login, deviceLabel, setDeviceLabel } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [trusted, setTrusted] = useState(true);
  const [error, setError] = useState("");
  const [working, setWorking] = useState(false);

  if (user) return <Navigate to="/" replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setWorking(true);
    setError("");
    try {
      await login(username, password, trusted);
      const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname;
      navigate(from || "/", { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Sign-in failed");
    } finally {
      setWorking(false);
    }
  }

  return (
    <div className="login-page">
      <section className="login-panel">
        <Brand />
        <div className="login-copy">
          <h1>Household inventory, ready to move.</h1>
          <p>Sign in on this iPhone or computer to scan, photograph, and update your move.</p>
        </div>
        <form onSubmit={submit}>
          <label>
            Username
            <input
              autoComplete="username"
              autoCapitalize="none"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
            />
          </label>
          <label>
            Password
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>
          <label>
            Device label
            <input
              value={deviceLabel}
              onChange={(event) => setDeviceLabel(event.target.value)}
              placeholder="Nicholas's iPhone"
            />
            <small>Voluntary; stored in this browser and included in activity records.</small>
          </label>
          <label className="toggle-row">
            <input
              type="checkbox"
              checked={trusted}
              onChange={(event) => setTrusted(event.target.checked)}
            />
            <span>
              Keep this household device signed in
              <small>Only takes effect when trusted-household mode is enabled.</small>
            </span>
          </label>
          {error && <p className="form-error">{error}</p>}
          <button className="button primary full" disabled={working}>
            {working ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="local-only-note">Private household system • Authorized users only</p>
      </section>
    </div>
  );
}
